import React, {useState} from 'react';
import PlanWizardStepOne from './PlanWizardStepOne';
import PlanWizardStepTwo from './PlanWizardStepTwo';
import PlanWizardStepThree from './PlanWizardStepThree';
import {NewPlanSchema} from '../../../api/DBSchema/Plan';
import Api from '../../../api/SMPFetchHelper';
import {ObjectTypes, ApiErrorCodes} from '../../../api/consts';
import {useIsMountedRef} from '../../../utils/hooks';
import {useSMCErrorHandler} from '../../../utils/errorUtils';
import {useTranslation} from 'react-i18next';
import SMCModal from '../../../components/core/SMCModal';

function PlanWizard({
    isOpen,
    onRequestClose,
    onSuccess
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();
    const isMountedRef = useIsMountedRef();

    const [isLoading, setIsLoading] = useState(false);
    const [wizardStep, setWizardStep] = useState(0);

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [storeGatewayLogs, setStoreGatewayLogs] = useState(true);
    const [sendPeriodicReports, setSendPeriodicReports] = useState(true);
    const [firmwareUpgrades, setFirmwareUpgrades] = useState(true);
    const [dynamicDns, setDynamicDns] = useState(true);
    const [sendCloudNotifications, setSendCloudNotifications] = useState(false);
    const [firewall, setFirewall] = useState(true);
    const [applicationControlAndUrlFiltering, setApplicationControlAndUrlFiltering] = useState(true);
    const [ips, setIps] = useState(true);
    const [traditionalAntiVirus, setTraditionalAntiVirus] = useState(true);
    const [antiSpam, setAntiSpam] = useState(true);
    const [qos, setQos] = useState(false);
    const [remoteAccessVpn, setRemoteAccessVpn] = useState(true);
    const [siteToSiteVpn, setSiteToSiteVpn] = useState(true);
    const [userAwareness, setUserAwareness] = useState(true);
    const [antiVirus, setAntiVirus] = useState(true);
    const [antiBot, setAntiBot] = useState(true);

    const finishWizard = async () => {
        const createPlanRequestObj = {
            [NewPlanSchema.name]: name,
            [NewPlanSchema.description]: description,
            [NewPlanSchema.storeGatewayLogs]: storeGatewayLogs,
            [NewPlanSchema.sendPeriodicReports]: sendPeriodicReports,
            [NewPlanSchema.firmwareUpgrades]: firmwareUpgrades,
            [NewPlanSchema.dynamicDns]: dynamicDns,
            [NewPlanSchema.sendCloudNotifications]: sendCloudNotifications,
            [NewPlanSchema.firewall]: firewall,
            [NewPlanSchema.applicationControlAndUrlFiltering]: applicationControlAndUrlFiltering,
            [NewPlanSchema.ips]: ips,
            [NewPlanSchema.traditionalAntiVirus]: traditionalAntiVirus,
            [NewPlanSchema.antiSpam]: antiSpam,
            [NewPlanSchema.qos]: qos,
            [NewPlanSchema.remoteAccessVpn]: remoteAccessVpn,
            [NewPlanSchema.siteToSiteVpn]: siteToSiteVpn,
            [NewPlanSchema.userAwareness]: userAwareness,
            [NewPlanSchema.antiVirus]: antiVirus,
            [NewPlanSchema.antiBot]: antiBot,
        }
        setIsLoading(true);
        try {
            await Api.createObject(ObjectTypes.PLAN, createPlanRequestObj);
            if (isMountedRef.current) {
                onSuccess(name);
            }
        } catch (e) {
            if (isMountedRef.current) {
                const errorMessage = getErrorMessage(e);
                if (errorMessage === ApiErrorCodes.GENERAL_ERROR) {
                    alert(t('SMP.PLAN.CREATE_NEW_PLAN_GENERAL_ERROR'));
                } else {
                    alert(errorMessage);
                }
            }
        } finally {
            if (isMountedRef.current) {
                setIsLoading(false);
            }
        }
    }

    const wizardVars = {
        onRequestClose,
        finishWizard,
        wizardStep, setWizardStep,
        name, setName,
        description, setDescription,
        storeGatewayLogs, setStoreGatewayLogs,
        sendPeriodicReports, setSendPeriodicReports,
        firmwareUpgrades, setFirmwareUpgrades,
        dynamicDns, setDynamicDns,
        sendCloudNotifications, setSendCloudNotifications,
        firewall, setFirewall,
        applicationControlAndUrlFiltering, setApplicationControlAndUrlFiltering,
        ips, setIps,
        traditionalAntiVirus, setTraditionalAntiVirus,
        antiSpam, setAntiSpam,
        qos, setQos,
        remoteAccessVpn, setRemoteAccessVpn,
        siteToSiteVpn, setSiteToSiteVpn,
        userAwareness, setUserAwareness,
        antiVirus, setAntiVirus,
        antiBot, setAntiBot
    }

    let WizardBody = null;

    switch (wizardStep) {
        case 0:
            WizardBody = PlanWizardStepOne;
            break;
        case 1:
            WizardBody = PlanWizardStepTwo;
            break;
        case 2:
            WizardBody = PlanWizardStepThree;
            break;
        default:
            onRequestClose();
            break;
    }

    return (
        <SMCModal
            title={t('SMP.PLAN.CREATE_NEW_PLAN')}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            width={610}
            height={600}
            loading={isLoading}
        >
            <WizardBody wizardVars={wizardVars} />
        </SMCModal>
    );
}

export default PlanWizard;